export default __webpack_public_path__ + "static/royceHall-17a761b8a21a68df3e3806accdb251e4.svg";